import {
  DOWNLOAD_ADD_SOFT,
  DOWNLOAD_ADD_SOFT_LIST,
  DOWNLOAD_CANCEL_SOFT,
  DOWNLOAD_GET_SOFT_LIST,
  DOWNLOAD_UPDATE_SOFT_LIST_STATE,
  DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS,
  DOWNLOAD_SHOW_FILE_ERROR,
  DOWNLOAD_SHOW_SIM,
  DOWNLOAD_CANENL,
} from '../constants/downloadTask';

export const downloadAddSoft = param => ({
  type: DOWNLOAD_ADD_SOFT,
  param,
});

export const downloadAddSoftList = params => ({
  type: DOWNLOAD_ADD_SOFT_LIST,
  params,
});

export const downloadCancelSoft = param => ({
  type: DOWNLOAD_CANCEL_SOFT,
  param,
});

export const downloadGetSoftList = param => ({
  type: DOWNLOAD_GET_SOFT_LIST,
  param,
});

export const downloadUpdateSoftListState = param => ({
  type: DOWNLOAD_UPDATE_SOFT_LIST_STATE,
  param,
});

export const downloadUpdateSoftListProgress = param => ({
  type: DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS,
  param,
});

export const downloadShowFileError = param => ({
  type: DOWNLOAD_SHOW_FILE_ERROR,
  payload: param,
});

export const downloadShowSIM = param => ({
  type: DOWNLOAD_SHOW_SIM,
  payload: param,
});

// 控制取消安卓应用准备中的下载
export const downloadCanenl = param => ({
  type: DOWNLOAD_CANENL,
  payload: param,
});
